document.addEventListener('DOMContentLoaded', handleGreetingCard);

function handleGreetingCard() {
    const textarea = document.querySelector('.boa-greeting-card .text-area');
    const checkboxButton = document.querySelector('.boa-greeting-card .checkbox-button');

    checkboxButton?.addEventListener('click', () => toggleCheckbox(checkboxButton));
    textarea?.addEventListener('input', () => handleTypingGreeting(textarea, checkboxButton));
}


function toggleCheckbox(checkboxButton){
    checkboxButton.classList.toggle('active');
    handleGreetingProperty(checkboxButton);
}

function handleTypingGreeting(textarea, checkboxButton) {
    const counter = document.querySelector('.boa-greeting-card .counter');
    const currentLength = textarea.value.length;
    counter.textContent = `${currentLength}/120`; // Update the counter
    handleGreetingProperty(checkboxButton);
}

function handleGreetingProperty(checkboxButton) {
    const isChecked = checkboxButton.classList.contains('active');
    const greeting = document.querySelector('.boa-greeting-card .text-area')?.value?.trim();
    const internalInput = document.querySelector(".product__form [name='properties[_greeting_card]']");
    const visibleInput = document.querySelector(".product__form [name='properties[כרטיס ברכה]']");
    if (!isChecked || !greeting) {
        [internalInput, visibleInput].forEach((input) => {
            if (!input) {
                return;
            }
            input.value = '';
            input.disabled = true;
        });
        return;
    }
    [internalInput, visibleInput].forEach((input) => {
        if (!input) {
            return;
        }
        input.value = greeting;
        input.disabled = false;
    });
}